import { GetterTree } from 'vuex';
import { ILookupResult } from '../shared-types';
import { IFundHistoryState } from './types';

const getters: GetterTree<IFundHistoryState, any> = {
  items(state): ILookupResult[] {
    return state.items;
  },
  businessCode(state): string {
    return state.businessCode;
  },
  selectedResultIndex(state): number {
    return state.selectedResultIndex;
  },
  selectedResult(state): ILookupResult | null {
    return state.items[state.selectedResultIndex];
  },
  cacheSuffix(state): string {
    return state.cacheSuffix;
  },
  mustHaveCacheSuffix(state): boolean {
    return state.mustHaveCacheSuffix;
  },
};

export default getters;
